import { useEffect, useState } from "react";
import "../theme/Header.css";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import { authProvider } from "../context/authProvider";
import "moment/locale/es";
import { VERSION_APP } from "../utilities";
import NotificationsIcon from "@mui/icons-material/Notifications";
import LogoutIcon from "@mui/icons-material/Logout";
import { grey } from "@mui/material/colors";
import { UseAdmin, UseAuth, UseUser, UseTokenGlobal } from "../hooks";
import { fetchSecciones } from "../Api/fetchSecciones";
import { useColoresEmpresa } from "../hooks/useColoresEmpresa";

import { getBrandLogo } from "../const/brandLogos";
import { useNavigate } from "react-router-dom";
import BRANDS from "../const/brands";

import { useBrandPreview } from "../context/BrandPreviewContext";

export const Header = () => {
  const navigate = useNavigate();

  const brandId = useColoresEmpresa();
  const { previewBrand, setPreviewBrand } = useBrandPreview();
  const activeBrandId = previewBrand || brandId;
  const { src: logoSrc, alt: logoAlt } = getBrandLogo(activeBrandId);

  const [isReporteShow, setIsReporteShow] = useState(false);
  const [isAdminShow, setIsAdminShow] = useState(false);
  const [reporteData, setReporteData] = useState(null);
  const [adminData, setAdminData] = useState(null);
  const { jobTitle } = UseUser();
  const { branchFiSucursalId, brandfiMarcaId, branchFiPaisId, rolId } = UseAdmin();

  const { signOut } = UseAuth();
  const { AdminOut } = UseAdmin();
  const { userOut } = UseUser();
  const { TokenOut } = UseTokenGlobal();

  const clearLocalStorage = () => {
    localStorage.clear();
  };

  const handleTokenExpiration = () => {
    console.log("handleTokenExpiration")
    authProvider.logout();
    signOut();
    userOut();
    AdminOut();
    TokenOut();
    clearLocalStorage()
  };

  useEffect(() => {
    getDataSeccion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branchFiPaisId, brandfiMarcaId, jobTitle, branchFiSucursalId, rolId]);

  const getDataSeccion = () => {
    if (
      branchFiPaisId !== null &&
      branchFiSucursalId !== null &&
      brandfiMarcaId !== null &&
      jobTitle !== null &&
      rolId !== null
    ) {
      const onFailure = ({ error }) => {
        console.log("error", error);
      };
      const onSuccess = ({ data }) => {
        const extractedData = data.body.seccion.CHILD1.map((item) => ({
          FCJSONSECCION2: item.FCJSONSECCION2,
          FCLINKSECCION2: item.FCLINKSECCION2,
          FCSEGUNDASECCION: item.FCSEGUNDASECCION,
          FCURLIMAGEN2: item.FCURLIMAGEN2,
          FISEGUNDASECCIONID: item.FISEGUNDASECCIONID,
          FCSTACKSECCION2: item.FCSTACKSECCION2,
          FCCHIL2: item.CHILD2,
        }));
        const contieneReportes = extractedData.some((item) => item.FCSEGUNDASECCION === "Reportes");
        setIsReporteShow(contieneReportes);

        const contieneAdmin = extractedData.some(
          (item) => item.FCSEGUNDASECCION === "Administración"
        );
        setIsAdminShow(contieneAdmin);

        if (contieneReportes) {
          const soloReportes = data.body.seccion.CHILD1.filter(
            (item) => item.FCSEGUNDASECCION === "Reportes"
          );
          setReporteData(soloReportes);
        }

        if (contieneAdmin) {
          const soloAministracion = data.body.seccion.CHILD1.filter(
            (item) => item.FCSEGUNDASECCION === "Administración"
          );
          setAdminData(soloAministracion);
        }
      };

      fetchSecciones(
        branchFiPaisId,
        brandfiMarcaId,
        jobTitle,
        branchFiSucursalId,
        VERSION_APP,
        Number(rolId)
      )
        .then(onSuccess)
        .catch(onFailure);
    }
  };

  const navigateToComunicados = () => {
    navigate(`/Comunicados`);
  };

  return (
    <AzureAD provider={authProvider}>
      {({ logout, authenticationState }) => {
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;

        if (isAuthenticated) {
          return (
            <div className="App-header App-header-phone">
              {/* Logo */}
              {/* <a
                className="image"
                href={`/Home`}
                style={{
                  cursor: "pointer",
                }}
              >
                <img className="image-logo" src={logoSrc} alt={logoAlt} />
              </a> */}

              {/* TODO: eliminar antes de pasar a produccion */}
              <div className="brand-preview-selector" style={{ marginLeft: 16 }}>
                {/* <label htmlFor="brand-preview" style={{ color: "white", marginRight: 6 }}>
                    Marca
                  </label> */}

                {/*<select*/}
                {/*  id="brand-preview"*/}
                {/*  value={previewBrand || ""}*/}
                {/*  onChange={(e) => setPreviewBrand(e.target.value || null)}*/}
                {/*  style={{*/}
                {/*    background: "white",*/}
                {/*    borderRadius: 6,*/}
                {/*    padding: "4px 6px",*/}
                {/*    minWidth: 140,*/}
                {/*  }}*/}
                {/*>*/}
                {/*  <option value="">Actual</option>*/}
                {/*  {Object.values(BRANDS).map(({ id }) => (*/}
                {/*    <option key={id} value={id}>*/}
                {/*      {id}*/}
                {/*    </option>*/}
                {/*  ))}*/}
                {/*</select>*/}
              </div>
              <div className="App-header-row">
                <button onClick={navigateToComunicados}>
                  <NotificationsIcon />
                </button>

                <button className="App-logout-button" onClick={handleTokenExpiration}>
                  <LogoutIcon />
                </button>
              </div>
            </div>
          );
        }
      }}
    </AzureAD>
  );
};
